module.exports = __webpack_public_path__ + "img/icon-position-over.4e89bd41.svg";